import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  changeProductStatus,
  getAllProducts,
} from "../../../redux/Actions/ProductActions";
import DeleteModal from "../../Modal/DeleteModal";

const ActivateProduct = (props) => {
  const {
    isChangingStatus,
    changeSuccess,
    changeProductStatus,
    getProducts,
    id,
  } = props;

  const changeStatus = () => {
    const payload = {
      status: "activate",
      id: id,
    };
    changeProductStatus(payload);
  };

  useEffect(
    () => {
      if (changeSuccess) {
        props.closeModal();
        getProducts(1, 10);
      }
    }, // eslint-disable-next-line
    [changeSuccess]
  );

  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Activate this product?"}
      width={"463px"}
      text={"Activate"}
      onClick={changeStatus}
      disabled={isChangingStatus}
      isLoading={isChangingStatus}
      activate={true}
      loadingText={"Activating..."}
      children={
        "Once you activate this product, this product would be active. Activate product?"
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isChangingStatus: state.products.isChangingStatus,
  changeSuccess: state.products.changeStatusSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (page, limit) => dispatch(getAllProducts(page, limit)),
  changeProductStatus: (payload) => dispatch(changeProductStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivateProduct);
